

















































































































































































































































































import Vue from "vue";
import {Component, Watch, Emit, Prop} from "vue-property-decorator";
import './interest.less';
import {Validations} from 'vuelidate-property-decorators';
import Stepper from "@/components/stepper/stepper.vue";
import {required, email, minValue, minLength, maxLength,numeric} from 'vuelidate/lib/validators';
import FileUpload from 'vue-upload-component'
import $ from 'jquery';
import SimpleDropdown from "@/components/simple-dropdown/simple-dropdown.vue";
import {submitInterestForm} from "@/service/webclient/webclient";

@Component({
    components: {
        Stepper,
        FileUpload,
        SimpleDropdown
    }
})
export default class interest extends Vue {

    public currentStep = 0;
    public maxCurrentStep = 0;
    public selectStep = 0;
    public isSubmitFormSend = false;
    public disabledNextButton = false;
    public beError = false;
    public errorsText = [];
    public steps = [{id: 1, title: 'Hőszigetelés dátum'},
        {id: 2, title: 'Épület adatai'},
        {id: 3, title: 'Személyes adatok'},
        {id: 4, title: 'Időpont'}];

    public epuletJellege = [
        {id: 1, title: "Családi ház"},
        {id: 2, title: "Társasház"},
        {id: 3, title: "Panel"}
    ];

    public epuletAllapota = [
        {id: 1, title: "Új építés"},
        {id: 2, title: "Felújítandó"},
        {id: 3, title: "Jó állapotú"},
        {id: 4, title: "Felújított"}
    ];
    public regisztraloStatusza = [
        {id: 1, title: "Magán építtető"},
        {id: 2, title: "Közös képviselő"},
        {id: 3, title: "Kivitelező"},
        {id: 4, title: "Egyéb"}
    ];

    public szaktanacsadoJelentkezhetTipus = [
        {id: 1, title: "Bármely napon"},
        {id: 2, title: "Meghatározott napon"},
        {id: 3, title: "Egész nap"}
    ];

    public step0 = {
        mikor_tervezi_a_hoszigetelest: 1
    };
    public step1 = {
        epulet_jellege: "",
        epulet_allapota: "",
        iranyitoszam: "",
        telepules: "",
        cim: "",
        hazszam: ""
        hoszigeteles_leirasa: ""
    };

    public step2 = {
        name: "",
        phone: "",
        email: "",
        regisztralo_statusza: "",
        regisztralo_statusza_egyeb: ""
    };
    public step3 = {
        szaktanacsado_jelentkezhet_tipus: "",
        szaktanacsado_jelentkezhet_pontositas: "",
        accept: false,
        accept2: false,
        accept3: false,
        accept4: false
    };


    mounted() {
        this.hiddenSlogen();
    }


    backStep() {
        if (this.currentStep != 0) {
            this.currentStep--;
        }
    }

    nextStep() {
        if (this.currentStep <= this.maxCurrentStep) {
            switch (this.currentStep) {
                case 0:

                    this.$v.step0.$touch();
                    setTimeout(() => {
                        if (!this.$v.step0.$invalid) {
                            this.currentStep++;
                            this.updateRequiredFieldsVisibility();
                            this.maxCurrentStep = 1;
                        }
                    }, 200);

                    break;
                case 1:

                    this.$v.step1.$touch();
                    setTimeout(() => {
                        if (!this.$v.step1.$invalid) {
                            this.currentStep++;
                            this.updateRequiredFieldsVisibility();
                            this.maxCurrentStep = 2;
                        }
                    }, 200);

                    break;
                case 2:
                    this.$v.step2.$touch();
                    setTimeout(() => {
                        if (!this.$v.step2.$invalid) {
                            this.currentStep++;
                             this.updateRequiredFieldsVisibility();
                            this.maxCurrentStep = 3;
                        }
                    }, 200);

                    break;
                case 3:
                    this.$v.step3.$touch();
                    setTimeout(() => {
                        if (!this.$v.step3.$invalid) {
                            this.submitForm();                            }
                    }, 200);

                    break;
                default:
                    break;
            }
        }
    }

    getEpuletJellegeId() {
        if (this.step1.epulet_jellege != "" && typeof this.step1.epulet_jellege.id != "undefined") {
            return this.step1.epulet_jellege.id;
        }
    }

    getEpuletAllapotaId() {
        if (this.step1.epulet_allapota != "" && typeof this.step1.epulet_allapota.id != "undefined") {
            return this.step1.epulet_allapota.id;
        }
    }

    getRegisztraloStatuszaId() {
        if (this.step2.regisztralo_statusza != "" && typeof this.step2.regisztralo_statusza.id != "undefined") {
            return this.step2.regisztralo_statusza.id;
        }
    }

    getSzaktanacsadoJelentkezhetTpusId() {
        if (this.step3.szaktanacsado_jelentkezhet_tipus != "" && typeof this.step3.szaktanacsado_jelentkezhet_tipus.id != "undefined") {
            return this.step3.szaktanacsado_jelentkezhet_tipus.id;
        }
    }
    backUrl(){
        history.back();
    }

  updateRequiredFieldsVisibility() {
    let requiredFieldsDiv = document.getElementById('required-fields-span');
    if ( requiredFieldsDiv ) {
      let visible = !this.isSubmitFormSend && this.currentStep >= 1 && this.currentStep <= 3;
      if ( visible ) {
        requiredFieldsDiv.className = 'd-block';
      } else {
        requiredFieldsDiv.className = 'd-none';
      }
    }
  }

    submitForm() {
        if (!this.$v.$invalid ) {
            let form = {
                "name": this.step2.name,
                "phone": this.step2.phone,
                "email": this.step2.email,
                "telepules": this.step1.telepules,
                "cim": this.step1.cim,
                "iranyitoszam": this.step1.iranyitoszam,
                "hazszam": this.step1.hazszam,
                "hoszigeteles_leirasa": this.step1.hoszigeteles_leirasa,
                "mikor_tervezi_a_hoszigetelest": this.step0.mikor_tervezi_a_hoszigetelest,
                "epulet_jellege": this.getEpuletJellegeId(),
                "epulet_allapota": this.getEpuletAllapotaId(),
                "regisztralo_statusza": this.getRegisztraloStatuszaId(),
                "regisztralo_statusza_egyeb": this.step2.regisztralo_statusza_egyeb,
                "szaktanacsado_jelentkezhet_tipus": this.getSzaktanacsadoJelentkezhetTpusId(),
                "szaktanacsado_jelentkezhet_pontositas": this.step3.szaktanacsado_jelentkezhet_pontositas,
                "accept": 1,
                "accept2": this.step3.accept2? 1: 0,
                "accept3": this.step3.accept3? 1: 0,
                "accept4": this.step3.accept4? 1: 0
            };
            this.disabledNextButton = true;
            this.beError = false;

            submitInterestForm(form).then((data) => {
                this.disabledNextButton = false;
                if (data.hiba == 0) {
                    this.isSubmitFormSend = true;
                    this.showSlogen();
                } else {
                    this.beError = true;
                    this.errorsText = data.mezok;
                }
            })
        }
    }

    hiddenSlogen(){
        /*$('.nyerjen-app-slogen-block').addClass('destop-content');*/
        $('.nyerjen-app-header-block').addClass('mb-4');
        $('.nyeremenyInfo').addClass('d-none');
        $('.regInfo').removeClass('d-none');
        this.updateRequiredFieldsVisibility();

    }

    showSlogen(){
        $('.nyerjen-app-slogen-block').removeClass('destop-content');
        $('.nyerjen-app-header-block').removeClass('mb-4');
        $('.nyeremenyInfo').removeClass('d-none');
        $('.regInfo').addClass('d-none');
        this.updateRequiredFieldsVisibility();
    }

    @Watch("selectedStep", {immediate: true, deep: true})
    onSelectStep(stepID) {
        if (typeof stepID != "undefined")
            this.currentStep = stepID;
    }


    @Validations()
    validations = {
        step0: {},
        step1: {
            epulet_jellege: {required},
            epulet_allapota: {required},
            iranyitoszam: {required, minLength: minLength(4), maxLength:maxLength(4),numeric},
            telepules: {required, minLength: minLength(3)},
            cim: {required, minLength: minLength(3)},
            hoszigeteles_leirasa: {},
            hazszam: {required, minLength: minLength(1)}
        },
        step2: {
            name: {required, minLength: minLength(3)},
            phone: {validatePhone: this.validatePhone, required},
            email: {required, email},
            regisztralo_statusza: {},
            regisztralo_statusza_egyeb: {}
        },
        step3: {
            szaktanacsado_jelentkezhet_tipus: {required},
            szaktanacsado_jelentkezhet_pontositas: {},
            accept: {},
            accept2: {required, maxLength: maxLength(4)},
            accept3: {},
            accept4: {}
        }
    }
  validatePhone(phone) {
    let regex = /(?:\+)(?:\d{1,2})(?:\ \d{1,2})(?:\ )(\d{3,4})(?:\ )?(\d{3,4})$/;
    if (!phone || phone.length == 0) {
      return true;
    } else {
      return regex.test(phone);
    }
  };


}
